<template>
  <div class="animated fadeIn">
    <div id="accueil-eb">
      <b-row>
        <b-col md="6" v-for="(news, index) in allNews" :key="index">
          <b-jumbotron :header="news.titre" class="lc-accueil-eb" :lead="news.texte">
            <span  v-if="canAccess(rules.MANAGE_NEWS_BO)">
              <a href="#" class="btn btn-primary stretched-link" @click="edit(news.id)"><i class="fa fa-edit"></i> Modifier</a>
            </span>
          </b-jumbotron>
        </b-col>
      </b-row>
      <b-row class="row-stats">
        <b-col md="12">
          <b-row>
            <b-col sm="4">
              <b-card>
                <div class="callout callout-success">
                  <small class="text-muted">Nombre total de bénéficiaires</small><br>
                  <strong class="h4">{{ formatNumber(countUsers) }}</strong>
                </div>
                <div class="progress-group">
                  <div class="progress-group-header"><i class="icon-user progress-group-icon"></i>
                    <span class="title">Bénéficiaires inscrits</span>
                    <span class="ml-auto font-weight-bold">{{ formatNumber(countLogin) }}
                      <span class="text-muted small">({{ percentageLogin }}%)</span>
                    </span>
                  </div>
                  <div class="progress-group-bars"><div class="progress-xs progress">
                    <div role="progressbar" aria-valuemin="0" aria-valuemax="100" v-bind:aria-valuenow="percentageLogin" class="progress-bar bg-success" :style="{ width: percentageLogin + '%' }"><!----></div>
                    </div>
                  </div>
                </div>
                <div class="progress-group">
                  <div class="progress-group-header"><i class="icon-user progress-group-icon"></i>
                    <span class="title">Comptes bénéficiaires actifs</span>
                    <span class="ml-auto font-weight-bold">{{ formatNumber(compteActive) }}
                      <span class="text-muted small">({{ percentageCactive }}%)</span>
                    </span>
                  </div>
                  <div class="progress-group-bars"><div class="progress-xs progress">
                    <div role="progressbar" aria-valuemin="0" aria-valuemax="100" v-bind:aria-valuenow="percentageCactive" class="progress-bar bg-success" :style="{ width: percentageCactive + '%' }"><!----></div>
                    </div>
                  </div>
                </div>
              </b-card>
            </b-col>
<!--             <b-col sm="4">
  <b-card>
    <div class="callout callout-warning">
      <small class="text-muted">Nombre total de justificatifs</small><br>
      <strong class="h4">{{ formatNumber(countJustifs) }}</strong>
    </div>
    <div class="progress-group">
      <div class="progress-group-header"><i class="icon-user progress-group-icon"></i>
        <span class="title">Justificatifs réclamés</span>
        <span class="ml-auto font-weight-bold">{{ formatNumber(claimedJustifs) }}
          <span class="text-muted small">(23.4 %)</span>
        </span>
      </div>
      <div class="progress-group-bars">
        <div class="progress-xs progress">
          <div role="progressbar" aria-valuemin="0" aria-valuemax="100" aria-valuenow="23" class="progress-bar bg-warning" style="width: 23%;"></div>
        </div>
      </div>
    </div>
  </b-card>
</b-col>
<b-col sm="4">
    <b-card>
      <div class="callout callout-info">
        <small class="text-muted">Example</small><br>
        <strong class="h4">{{ formatNumber(999999) }}</strong>
      </div>
      <div class="progress-group">
        <div class="progress-group-header"><i class="icon-user progress-group-icon"></i>
          <span class="title">Example</span>
          <span class="ml-auto font-weight-bold">{{ formatNumber(99999) }}
            <span class="text-muted small">(99 %)</span>
          </span>
        </div>
        <div class="progress-group-bars"><div class="progress-xs progress">
          <div role="progressbar" aria-valuemin="0" aria-valuemax="100" aria-valuenow="23" class="progress-bar bg-info" style="width: 23%;"></div>
          </div>
        </div>
      </div>
    </b-card>
</b-col> -->
          </b-row>
        </b-col>
      </b-row>
    </div>
  </div>
</template>

<script>
import { getBaseUrl, getProvider, getIdToken, getAccessToken } from '../../utils/auth'
import {espaceBeneficiaireRules, hasRule} from '../../utils/rulesHelper'

export default {
  data() {
    return {
      rules: espaceBeneficiaireRules,
      allNews: [],
      countUsers: '',
      countLogin: '',
      compteActive: '',
      countJustifs: '',
      claimedJustifs: '',
      percentageLogin: '',
      percentageCactive: ''
    }
  },
  mounted() {
    this.getNewsEb()
    this.infosAccueil()
  },
  created() {
    this.$axios.defaults.baseURL = getBaseUrl();
    this.$axios.defaults.headers.common["Authorization"] = getIdToken() + " " + getAccessToken();
    this.$axios.defaults.headers.common["Accept"] = "application/json";
    this.$axios.defaults.headers.common["Provider"] = getProvider();
  },
  methods: {
    canAccess(rule) {
      return hasRule(rule)
    },
    getNewsEb() {
      let self = this;
      this.$store.commit("IS_LOADING", true);
      this.$axios
        .get("/espaceBeneficiaire/newsEb")
        .then(response => {
          this.$store.commit("IS_LOADING", false)
          this.allNews = response.data.newsEb
        })
        .catch(function(error) {
          self.$store.commit("IS_LOADING", false);
          self.$swal({
            position: "top",
            type: "error",
            title: "Attention !!",
            text: "Une erreur est survenue, si le problème persiste merci de faire un ticket au support DOSI",
            showConfirmButton: false,
            timer: 5000
          });
        });
    },
    edit(id) {
      this.$router.push({ path: '/espace-beneficiaire/accueil/actualitesBo/edit/' + id })
    },
    infosAccueil() {
      let self = this;
      this.$store.commit("IS_LOADING", true);
      this.$axios
        .get("/espaceBeneficiaire/accueil")
        .then(response => {
          this.$store.commit("IS_LOADING", false)
          this.countUsers = response.data.countUsers
          this.countLogin = response.data.countLogin
          this.percentageLogin = Math.round(response.data.percentageLogin)
          this.compteActive = response.data.compteActive
          this.percentageCactive = Math.round(response.data.percentageCactive)
          this.countJustifs = response.data.countJustifs
          this.claimedJustifs = response.data.claimedJustifs
        })
        .catch(function(error) {
          self.$store.commit("IS_LOADING", false);
          self.$swal({
            position: "top",
            type: "error",
            title: "Attention !!",
            text: "Une erreur est survenue, si le problème persiste merci de faire un ticket au support DOSI",
            showConfirmButton: false,
            timer: 5000
          });
        });
    },
    formatNumber(num) {
      return num.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1 ')
    }
  }
}
</script>

<style>
  body {
    /*background-image: url("/../../../img/brand/montgolfiere.jpg");
    background-repeat: no-repeat;
    background-size: cover;*/
  }
</style>
